import { Record, List } from 'immutable';
import { TAB_KEY, SELECTIVE_TRANSFER_PAGE } from 'constants/assetTransfer';
import Account from 'records/AssignedAccount';

const assetTransferThreshold = Number(APP_CONFIG.assetTransferThreshold);
const assetTransferAllowedCount = Number(APP_CONFIG.assetTransferAllowedCount);

export const defaultSelectiveTransferTab = {
  isObsolete: true,
  isAllSelected: false,
  data: new List(),
  selectedAssets: [],
  dependenciesLocked: false,
  links: [],
};


export class SelectiveTransferTab extends Record(defaultSelectiveTransferTab, SelectiveTransferTab) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const defaultValues = {
  currentPage: SELECTIVE_TRANSFER_PAGE.SELECT_ASSETS,
  currentTab: TAB_KEY.RECIPE,
  transferType: null,
  transferNote: null,
  isLoading: false,
  isRequestingTransfer: false, // initiating a transfer
  isSelectedView: false,
  errorMessage: null,
  source: new Account(),
  destinations: new List(),
  sourceHasAssets: false,
  isImportView: false,
  assetTransferThreshold: assetTransferThreshold,
  assetTransferAllowedCount: assetTransferAllowedCount,
  [TAB_KEY.RECIPE]: new SelectiveTransferTab(),
  [TAB_KEY.BATCH_RECIPE]: new SelectiveTransferTab(),
  [TAB_KEY.CUSTOM_INGREDIENT]: new SelectiveTransferTab(),
  [TAB_KEY.MENU]: new SelectiveTransferTab(),
  [TAB_KEY.DESIGN]: new SelectiveTransferTab(),
};

export default class SelectiveTransfer extends Record(defaultValues, SelectiveTransfer) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
